const PARTICIPATION_SENTIMENT = {
  POSITIVE: 1,
  NEGATIVE: -1,
}

module.exports = {
  PARTICIPATION_SENTIMENT,
}
